module.exports = __webpack_public_path__ + "img/andriod-white.bcb28e60.svg";